import { addMonths, isSameDay, isSameMonth, parse } from 'date-fns';
import { requiresParsing } from './parse';

// date-fns treats 'yyyy-MM-dd' strings as UTC midnight, which shifts them to
// the previous day in negative UTC offsets, so parse them as local dates
export const toLocalDate = (date) => {
  if (!requiresParsing(date)) {
    return date;
  }
  const parsed = parse(date, 'yyyy-MM-dd', new Date());
  return Number.isNaN(parsed.getTime()) ? date : parsed;
};

export const isSameLocalDay = (left, right) => {
  return isSameDay(toLocalDate(left), toLocalDate(right));
};

export const findMatchingRangeIndex = (ranges, start, end) => {
  return ranges.findIndex((element) => {
    return (
      isSameLocalDay(element.value[0], start) &&
      isSameLocalDay(element.value[1], end)
    );
  });
};

export const calulateIsAllTime = (selectedIndex, nextSelectedIndex, ranges) => {
  const allTimeRangeIndex = ranges.findIndex((element) => {
    return element.isAllTime;
  });

  return nextSelectedIndex !== null
    ? nextSelectedIndex === allTimeRangeIndex
    : selectedIndex === allTimeRangeIndex;
};

export const calculateThisMonth = (
  selectedIndex,
  nextSelectedIndex,
  ranges
) => {
  const thisMonthRangeIndex = ranges.findIndex((element) => {
    return element.isThisMonth;
  });

  return nextSelectedIndex !== null
    ? nextSelectedIndex === thisMonthRangeIndex
    : selectedIndex === thisMonthRangeIndex;
};

const isDateOrString = (x) => {
  return typeof x === 'string' || x instanceof Date;
};

export const calculateCalendarDate = (
  value,
  selectedIndex,
  nextSelectedIndex,
  ranges
) => {
  if (value && isDateOrString(value[0]) && isDateOrString(value[1])) {
    const start = toLocalDate(value[0]);
    const end = toLocalDate(value[1]);

    if (calulateIsAllTime(selectedIndex, nextSelectedIndex, ranges)) {
      return [start, end];
    }
    if (calculateThisMonth(selectedIndex, nextSelectedIndex, ranges)) {
      return [addMonths(start, -1), end];
    }
    const sameMonth = isSameMonth(start, end);
    return [start, sameMonth ? addMonths(end, 1) : end];
  }
  return [new Date(), addMonths(new Date(), 1)];
};
